module.exports = "<div class=\"loader\" *ngIf=\"isEnabled\" [ngStyle]=\"{'top': config.topOffset}\">\n    <img class=\"loader--inner\" src=\"" + require("../../../img/loader.gif") + "\">\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loader/loader.html
// module id = 769
// module chunks = 0